module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      connected: _vm.isConnected, groupSelected: !_vm.isAllGroopsSelected
    },
    attrs: {
      "id": "body"
    }
  }, [(_vm.ready) ? [_c('shared-object-viewer'), _c('context-menu'), _c('div', {
    staticClass: "wrapper"
  }, [_c('header', {
    staticClass: "public-main-header"
  }, [_c('a', {
    staticClass: "logo",
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_vm._m(0)])]), _c('header', {
    staticClass: "main-header",
    class: {
      searchOpen: _vm.searchOpen || _vm.searchText
    }
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_vm._m(1)]), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('header-user-dropdown'), _c('header-group-selection'), _c('header-search-form')], 1)]), _c('sidebar-menu'), _c('answering-hover'), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('search-helper'), ((!_vm.isConnected && _vm.$route.meta && !_vm.$route.meta.needConnected) || _vm.groopsAreLoaded) ? _c('router-view') : _c('div', {
    staticClass: "alert alert-default"
  }, [_vm._v(_vm._s(_vm.$t("home.groupsLoading")))])], 1)], 1), _c('events-create-event-modal', {
    attrs: {
      "eventsBus": _vm.eventsBus
    }
  }), _c('events-import-i-c-s-modal', {
    attrs: {
      "eventsBus": _vm.eventsBus
    }
  }), _c('quick-chat-conversation'), _c('key-shortcuts'), _c('modal-account'), _c('connection-modal'), _c('shared-object-members'), _c('new-group'), _c('new-members'), _c('vue-select-a-group-modal')] : [_c('div', {
    staticClass: "home-waiting"
  })], _c('footer', [_c('cookie-law', {
    attrs: {
      "theme": "dark-lime",
      "buttonText": _vm.$t('cookiesAlert.btn')
    }
  }, [_c('div', {
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v(_vm._s(_vm.$t("cookiesAlert.text")))])])], 1), _c('link', {
    attrs: {
      "href": "//fonts.googleapis.com/css?family=Source+Sans+Pro",
      "rel": "stylesheet",
      "type": "text/css",
      "async": ""
    }
  }), _c('link', {
    attrs: {
      "href": "//fonts.googleapis.com/css?family=Lato:400,300,700'",
      "rel": "stylesheet",
      "type": "text/css",
      "async": ""
    }
  }), _c('link', {
    attrs: {
      "href": "https://unpkg.com/emoji.css/dist/emoji.min.css",
      "rel": "stylesheet"
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publicBars"
  }, [_c('i', {
    staticClass: "fa fa-bars closed"
  }), _c('i', {
    staticClass: "fa fa-times open"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('div', {
    staticClass: "letter"
  }, [_c('img', {
    attrs: {
      "src": "static/logo.png"
    }
  })]), _c('div', {
    staticClass: "bars"
  }, [_c('i', {
    staticClass: "fa fa-bars closed"
  }), _c('i', {
    staticClass: "fa fa-times open"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d29e085e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/Home.vue
// module id = 1285
// module chunks = 1